import React from 'react';
import { AnimatedSection, ParallaxLayer } from './AnimatedSection';
import { BlurText, HeroBackground } from './Animations';
import { Link } from 'react-router-dom';
import { SplineBackground } from './SplineBackground';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  eyebrow?: string;
  headline: string;
  subhead: string;
  primaryCta?: {
    label: string;
    to: string;
  };
  secondaryCta?: {
    label: string;
    to: string;
  };
  graphic?: React.ReactNode;
  centered?: boolean;
}
export function HeroSection({
  eyebrow,
  headline,
  subhead,
  primaryCta,
  secondaryCta,
  graphic
}: HeroSectionProps) {
  return <section className="relative pt-40 pb-20 overflow-hidden border-b border-picus-border" data-id="element-272">
      <ParallaxLayer speed={0.5} className="absolute inset-0 z-0 pointer-events-none" data-id="element-273">
        <SplineBackground data-id="element-274" />
        <HeroBackground data-id="element-275" />
      </ParallaxLayer>

      <div className="section-container relative z-10" data-id="element-276">
        <div className="flex" data-id="element-277">
          {/* Vertical Progress Bar */}
          <ParallaxLayer speed={0.2} className="hidden md:flex flex-col w-4 mr-12 mt-4" data-id="element-278">
            <div className="w-full h-14 bg-white mb-1" data-id="element-279" />
            {[...Array(16)].map((_, i) => <div key={i} className="w-full h-14 border-b border-white/20" data-id="element-280" />)}
          </ParallaxLayer>

          <div className="flex-1 max-w-3xl pt-16 pb-32" data-id="element-281">
            {eyebrow && <AnimatedSection data-id="element-282">
                <div className="font-mono text-[12px] leading-[16px] font-medium uppercase tracking-[2.4px] text-white mb-12" data-id="element-283">
                  {eyebrow}
                </div>
              </AnimatedSection>}

            <h1 className="mb-12" data-id="element-284">
              <BlurText text={headline} data-id="element-285" />
            </h1>

            <AnimatedSection delay={0.3} data-id="element-286">
              <p className="mb-16 max-w-2xl" data-id="element-287">
                {"Picus Platform gives security teams real-time, context-rich validation across controls, exposures, and attack paths. It learns your infrastructure and your defenses to show you exactly what's working and what's not, why it matters, and how to close the gaps. With Picus, you can confidently answer the most critical questions: could an attacker get in, would we detect & prevent, and if not, what should we fix first?"}
              </p>
            </AnimatedSection>

            {(primaryCta || secondaryCta) && <AnimatedSection delay={0.4} className="flex flex-col sm:flex-row items-start gap-6" data-id="element-288">
                {primaryCta && <Link to={primaryCta.to} className="btn-primary" data-id="element-289">
                    {primaryCta.label}
                  </Link>}
                {secondaryCta && <Link to={secondaryCta.to} className="btn-secondary flex items-center gap-2" data-id="element-290">
                    {secondaryCta.label} <ArrowRight className="w-3 h-3" data-id="element-291" />
                  </Link>}
              </AnimatedSection>}
          </div>
        </div>

        {graphic && <ParallaxLayer speed={-0.1} data-id="element-292">
            <AnimatedSection delay={0.5} className="relative z-10 mt-12 w-full max-w-5xl mx-auto" data-id="element-293">
              {graphic}
            </AnimatedSection>
          </ParallaxLayer>}
      </div>
    </section>;
}